import { AbLogin } from 'app/abstract/content-pages/login/login.abstract';
import { getLeafInjector } from 'app/angular-leaf.bootstrap';

// Porta entre a Navbar React e o Angular: resolve os services do injector da
// folha em execução em vez de instanciá-los soltos, para reusar exatamente o
// singleton da folha montada. O logout NÃO passa mais por aqui — o React encerra
// a própria sessão (effects/logout + http/session-cleanup); esta ponte cobre só
// o refresh de token, que depende do AbLogin do Angular.

/**
 * Delega o refresh de token ao Angular (AbLogin.refreshToken), disparado na troca
 * de conta e ao sair da conta. Sem folha montada, não há sessão Angular para
 * atualizar — a chamada é um no-op registrado em log.
 */
export function refreshTokenViaAngular(tenant: unknown): void {
  const injector = getLeafInjector();
  if (!injector) {
    console.warn('[auth-bridge] refreshTokenViaAngular chamado sem folha Angular montada; ignorando.');
    return;
  }

  injector.get(AbLogin).refreshToken(tenant);
}
